import React, { useContext } from "react";

export const AdminContext = React.createContext({});
export const useAdminContext = () => useContext<any>(AdminContext);
